import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UserAvatar from '../Avatars/UserAvatar';
import CommentDropdown from './CommentDropdown';
import CommentLikeButton from './CommentLikeButton';
import CommentReplyButton from './CommentReplyButton';

const BasicComment = ({ userAccess, comment, onLikeClick, onDeleteClick, onReportClick, onReplyClick }) => {
  const { id, content, owner_id, owner_image_url, owner_full_name, my_comment, ago, likes, liked, reported, locked, real_deal } = comment;

  const basicCommentClass = classNames('basic-comment d-flex', {
    'basic-comment--my-comment': my_comment,
    'basic-comment--reported': reported,
    'basic-comment--locked': locked,
  });

  let commentText;
  if (reported === true) {
    commentText = 'This comment has been reported as offensive and is currently under review';
  } else {
    commentText = content;
  }

  return (
    <div className={basicCommentClass}>
      <UserAvatar image={owner_image_url} verified={real_deal} />

      <div className="flex-grow-1">
        <div className="basic-comment__header">
          <a href={`/user/${owner_id}`} target="_blank" className="green-link fw-medium m-r-1 text-capitalize">{owner_full_name}</a>
          <span className="h5 text-grey">{ago}</span>

          {userAccess &&
            <CommentDropdown myComment={my_comment} locked={locked} deleteComment={() => onDeleteClick(id)} reportComment={() => onReportClick(id)} />
          }
        </div>

        <div className="basic-comment__text"><p>{commentText}</p></div>

        {userAccess &&
          <div className="basic-comment__actions m-t-1">
            <CommentLikeButton likes={likes} liked={liked} onClick={() => onLikeClick(id, liked)} />
            <CommentReplyButton onClick={onReplyClick} />
          </div>
        }
      </div>
    </div>
  );
};

BasicComment.propTypes = {
  userAccess: PropTypes.string.isRequired,
  comment: PropTypes.object.isRequired,
  onLikeClick: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  onReportClick: PropTypes.func.isRequired,
  onReplyClick: PropTypes.func.isRequired,
};

export default BasicComment;



// WEBPACK FOOTER //
// ./library/app/components/Global/Comments/BasicComment.js